import { render } from "./PackageDetailModal.vue?vue&type=template&id=b33e77e0&scoped=true"
import script from "./PackageDetailModal.vue?vue&type=script&lang=js"
export * from "./PackageDetailModal.vue?vue&type=script&lang=js"

import "./PackageDetailModal.vue?vue&type=style&index=0&id=b33e77e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b33e77e0"]])

export default __exports__